const frameExecuted = [];
const sizeExecuted = [];
const pptExecuted = [];


frameBuilder = function frameBuilder(option, artContainer) {
  if (frameExecuted.includes(artContainer) === false) {
    option -= 1;
    frameToHide = document.querySelector("#" + artContainer + ' option[data-default="frame"]');
    console.log("frameToHide: " + frameToHide);
    frameToHide.remove();
    frameExecuted.push(artContainer);
  } else {
    
  }
  artwork = document.querySelector("#" + artContainer);
  selectedOption = 'option-1-' + option;
  artwork.dataset.frame = selectedOption;
  console.log(frameExecuted);
}

sizeBuilder = function sizeBuilder(option, artContainer) {
  if (sizeExecuted.includes(artContainer) === false) {
    sizeToHide = document.querySelector("#" + artContainer + ' option[data-default="size"]');
    console.log("sizeToHide: " + sizeToHide);
    sizeToHide.remove();
    sizeExecuted.push(artContainer);
  }
  artwork = document.querySelector("#" + artContainer);
  selectedOption = "size-" + option.replace(/["'\s]/g, '');
  artwork.dataset.size = selectedOption;
}

pptBuilder = function pptBuilder(option, artContainer) {
  if (pptExecuted.includes(artContainer) === false) {
    console.log(pptExecuted);
    option -= 1;
    pptToHide = document.querySelector("#" + artContainer + ' option[data-default="ppt"]');
    pptToHide.remove();
    pptExecuted.push(artContainer);
  }
  artwork = document.querySelector("#" + artContainer);
  selectedOption = 'option-3-' + option;
  artwork.dataset.ppt = selectedOption;
  console.log(pptExecuted);
}

initialBuilder = function initialBuilder(artContainer) {
  artwork = document.querySelector("#" + artContainer);  
  frameOption = document.querySelector('#' + artContainer + ' ' + 'input[data-type="frame"]:checked').className.trim();
  sizeOption = "hello-";
  pptOption = document.querySelector('#' + artContainer + ' ' + 'input[data-type="ppt"]:checked').className.trim();
  console.log("frameeeeee: " + frameOption + "sizeeeee: " + sizeOption + "ppt: " + pptOption);
  console.log("frameeeeee: " + option + "/ artContainer:" + artContainer);
  artwork.dataset.frame = frameOption;
  artwork.dataset.size = "size-" + option.replace(/["'\s]/g, '');
  artwork.dataset.ppt = pptOption;
}
